import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NetworkStatusService } from 'app/@core/services/utility/network-status.service';

@Component({
  selector: 'offline-banner',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './offline-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineBannerComponent {
  readonly networkStatus = inject(NetworkStatusService);
}
